import React from 'react'
import {Field, ErrorMessage} from "formik";

const TextareaField = ({form, field, label_text, helper_text, password, isDisabled, type,isRequired}) => {
    return (
        <>
            <div>
                {
                    label_text&&
                    <label htmlFor="fname" className={"text-xs font-medium inline-block"}>{label_text}{isRequired && <span className=''>*</span>}</label>
                }
                <Field 
                    as={"textarea"}
                    type={type ? type : "text"}
                    name={field}
                    id={field}
                    disabled={isDisabled}
                    placeholder={helper_text ? helper_text : ""}
                    className={`resize-none h-[100px] disabled:bg-gray-100 disabled:cursor-not-allowed input-text ${form.touched[field] && form.errors[field] ? "input-text-error" : ""} ${form.values[field] && form.values[field].toString().length > 0 && "input-text-active"}`}
                />
                <p className="text-xs text-red-500">
                    <ErrorMessage name={field} />
                </p>
            </div>
        </>
    )
}

export default TextareaField